import { IconCopy, IconX } from '@tabler/icons-react';
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { getApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { toast } from 'sonner';
import IconButton from '../../../components/Buttons/IconButton';

const CdnModal = () => {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [cdnData, setCdnData] = useState(null);

    const getCdnData = async () => {
        loadingShow();
        let resp = await getApi(urlApi.getCdnData);
        loadingHide();
        if (resp.responseCode === 200) {
            setCdnData(resp.data);
            handleShow();
        } else {
            toast.error(resp.message);
            setCdnData(null);
        }
    }

    function onCopy(copyText) {
        navigator.clipboard
            .writeText(copyText)
            .then(() => {
                toast.success("CDN copied");
            })
            .catch(() => {
                toast.error("something went wrong");
            });
    }

    return (
        <>
            <button className='text-xs bg-green-300 shadow-sm !px-2 !py-0.5 text-gray-700 rounded-md font-semibold' onClick={getCdnData}>Get CDN</button>
            <Modal show={show} onHide={handleClose} backdrop="static" size='lg'>
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold mb-0">Get CDN for your app.</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div className="flex gap-3 py-10">
                        <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" value={cdnData} readOnly />
                        <IconButton icon={<IconCopy />} onClickFunction={() => onCopy(cdnData)} />
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CdnModal